'use client'

import React, { useMemo } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { usePathname } from 'next/navigation'
import { DASHBOARD_DATA } from './AllDashboards.data'
import { DashboardItem } from './AllDashboards.interface'
import styles from './AllDashboards.module.scss'

const AllDashboards: React.FC = () => {
  const pathname = usePathname()

  const filteredDashboards = useMemo(() => {
    return DASHBOARD_DATA.filter((dash) => dash.link !== pathname && dash.image)
  }, [pathname])

  return (
    <section className={`py-5`}>
      <div className="container font-dm-mono max-w-full">
        <div className="flex flex-wrap -mx-2.5">
          {filteredDashboards.map((dashboard: DashboardItem, index: number) => (
            <div className="w-full md:w-1/2 lg:w-1/2 pt-2.5 px-2.5" key={dashboard.link}>
              <Link href={dashboard.link} className={`${styles.dashboardCardLink} block h-full`}>
                <div className={styles.dashboardCard}>
                  <div className={styles.thumbnail}>
                    <Image
                      src={dashboard.imagelink}
                      alt={dashboard.linkText}
                      fill
                      style={{ objectFit: 'cover' }}
                      sizes="(max-width: 768px) 100vw, 50vw"
                      priority={index < 2}
                    />
                  </div>

                  <div className={styles.content}>
                    <h3
                      className={`text-white text-normal mb-[15px] text-[20px]`}
                      title={dashboard.linkText}
                    >
                      {dashboard.linkText}
                    </h3>
                    <p className={`text-white text-[16px] opacity-60`}>{dashboard.description}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AllDashboards
